import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-nudge',
  templateUrl: './common-nudge.component.html',
  styleUrls: ['./common-nudge.component.scss']
})
export class CommonNudgeComponent {


  @Input() headingText: string;
  @Input() paragraphText: string;
  @Input() submitButtonText: string;

  @Input() nudgeIcon: string;

  @Output() emitOnHidden: EventEmitter<string> = new EventEmitter();


  /**
   * submit button function
   */
  onSubmit(): void {
    // 
  }

  /**
   * close pop up
   */
  onHidden(): void {
    this.emitOnHidden.emit();
  }
}